import { LoadingButton } from '@mui/lab';
import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useActiveClassroom, useActiveSimulation } from '../active-simulation/useActiveSimulation';
import { useJoinClassroom, useLeaveClassroom } from '../api';
import ErrorDialog from '../error-dialog/ErrorDialog';
import ClassroomJoinPanel from '../student-join-panel/ClassroomJoinPanel';
import { ClassroomStudentStatus, SimulationRole } from '../types';
import { isInstructorClassroom, isLoading, isRunning } from '../utils/activeSimulation';
import { useGetErrorMessage } from '../utils/useGetErrorMessage';

const JoinClassroom = () => {
  const { activeClassroom, isLoadingActiveClassroom, setActiveClassroom } = useActiveClassroom();
  const { activeSimulation, isLoadingActiveSimulation } = useActiveSimulation();

  const [joining, setJoining] = useState(false);
  const { joinClassroom, isJoinLoading, joinClassroomError } = useJoinClassroom(activeClassroom?.id, () => {
    setJoining(true); // Wait for SignalR message
  });
  useEffect(() => {
    if (activeClassroom) {
      setJoining(false);
    }
  }, [activeClassroom]);

  const { leaveClassroom, isLeaving, leaveClassroomError } = useLeaveClassroom(activeClassroom?.id, () =>
    setActiveClassroom(null),
  );

  const [errorMessage, showErrorDialog, setShowErrorDialog] = useGetErrorMessage(joinClassroomError ?? undefined);
  const [leaveErrorMessage, showLeaveErrorDialog, setShowLeaveErrorDialog] = useGetErrorMessage(
    leaveClassroomError ?? undefined,
  );

  if (isLoadingActiveClassroom || isLoadingActiveSimulation) return null;

  if (activeSimulation?.role === SimulationRole.Student) {
    return (
      <ClassroomJoinPanel
        exerciseId={activeSimulation.exercise?.id}
        simulationId={activeSimulation.id}
        exerciseName={activeSimulation.exercise.name}
        position={activeSimulation.position}
        simulatorLoading={isLoading(activeSimulation)}
        simulatorReady={isRunning(activeSimulation)}
        url={activeSimulation?.url}
      />
    );
  } else if (activeClassroom && !isInstructorClassroom(activeClassroom)) {
    return (
      <>
        <ClassroomJoinPanel
          exerciseName={
            activeClassroom.status === ClassroomStudentStatus.Joined ? activeClassroom.exercise.name : undefined
          }
          joining={joining}
          joinButton={
            <LoadingButton loading={isJoinLoading} variant="contained" onClick={() => joinClassroom()}>
              Join session
            </LoadingButton>
          }
          leaveButton={
            <LoadingButton loading={isLeaving} onClick={() => leaveClassroom()}>
              Leave
            </LoadingButton>
          }
          position={activeClassroom.position}
        />

        <ErrorDialog message={errorMessage} open={showErrorDialog}>
          <Button onClick={() => setShowErrorDialog(false)} variant="contained">
            Dismiss
          </Button>
        </ErrorDialog>

        <ErrorDialog message={leaveErrorMessage} open={showLeaveErrorDialog}>
          <Button onClick={() => setShowLeaveErrorDialog(false)} variant="contained">
            Dismiss
          </Button>
        </ErrorDialog>
      </>
    );
  }

  return null;
};

export default JoinClassroom;
